// Angular imports
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

// Import column types
import { ColumnMap } from '../../types';
import { ViewModelLine } from 'src/app/state-management/calculation-state';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state-management/app-state';

@Component({
    selector: 'sub-category-row',
    templateUrl: './sub-category-row.component.html',
    styleUrls: ['./sub-category-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SubCategoryRowComponent implements OnInit {
    public subcategory$ = new BehaviorSubject<ViewModelLine | undefined>(undefined);
    
    @Input() public set subcategory(value: ViewModelLine){
        this.subcategory$.next(value);
        // console.log('VALUE', value);
    };
    @Input() public columns: ColumnMap;

    constructor() {
    }

    public ngOnInit() {
    }

    public onDestroy(){
    }
}
